import { PackageSizeEnum, PackageSizeFormValues } from '@/components/OrderForm/PackageSizeCard';
import { useFetchOrderExcelByUID } from '@/hooksApi/useImport';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

export interface StepProps {
  id?: string | null;
  setRow?: (value: number) => void;
  selectedPickupAddressId?: string;
}

const Step2 = ({ id }: StepProps) => {
  const { t } = useTranslation();

  const { data: dataOrderExcel, isLoading: loadingOrderExcel } = useFetchOrderExcelByUID(
    id as string,
  );

  const RowFirstOrderExcel = dataOrderExcel?.object?.items?.[0];

  const dataSourceCsv = [
    { key: '1', label: t('custom_id'), value: RowFirstOrderExcel?.custom_id || '---' },
    { key: '2', label: t('city'), value: RowFirstOrderExcel?.region?.province || '---' },
    { key: '3', label: t('area'), value: RowFirstOrderExcel?.region?.area_name || '---' },
    { key: '4', label: t('address'), value: RowFirstOrderExcel?.address_text || '---' },
    {
      key: '5',
      label: t('package_size'),
      value: (() => {
        const size = String(t(PackageSizeEnum[RowFirstOrderExcel?.size as PackageSizeFormValues]) || 'Unknown size');
        return size.charAt(0).toUpperCase() + size.slice(1);
      })(),
    },
  ];

  return (
    <div className='border border-solid border-[rgb(232,230,227)] rounded-2xl bg-white p-6'>
      <h2 className='text-base font-semibold text-sd-foreground mt-0 mb-1'>{String(t('preview_data'))}</h2>
      <p className='text-sm text-[#737b8c] mt-0 mb-4'>
        {String(t('review_first_row_data'))}
      </p>

      {loadingOrderExcel ? (
        <div className='flex justify-center py-8'>
          <Spin />
        </div>
      ) : (
        <div className='rounded-[10px] border border-solid border-[#e8e6e3] overflow-hidden'>
          <table className='w-full text-sm' style={{ borderCollapse: 'collapse' }}>
            <tbody>
              {dataSourceCsv.map((row, index) => (
                <tr
                  key={row.key}
                  style={index < dataSourceCsv.length - 1 ? { borderBottom: '1px solid #e8e6e3' } : undefined}
                >
                  <td
                    className='w-[180px] font-medium text-[#737b8c] p-4 align-middle'
                    style={{ backgroundColor: 'rgba(241, 240, 238, 0.4)' }}
                  >
                    {row.label}
                  </td>
                  <td className='p-4 align-middle text-sd-foreground'>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Step2;
